import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import '@mdi/font/css/materialdesignicons.css';
import './filter';
import LoadingComponent from '@/components/Loading.component.vue';
import '@/styles/styles.scss';

import Notifications from 'vue-notification';
import ConfirmDialogComponent from '@/components/dialog/ConfirmDialog.component.vue';

// Global loading component
Vue.component('LoadingComponent', LoadingComponent);
Vue.component('ConfirmDialogComponent', ConfirmDialogComponent);

Vue.use(Notifications);

// Leaflet
// @ts-ignore
import { Icon } from 'leaflet';
import { LMap, LTileLayer, LMarker, LWMSTileLayer, LIcon, LPopup } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
// @ts-ignore
import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster';

// @ts-ignore
delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

Vue.config.productionTip = false;

Vue.component('l-map', LMap);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);
Vue.component('l-icon', LIcon);
Vue.component('l-popup', LPopup);
Vue.component('v-marker-cluster', Vue2LeafletMarkerCluster);

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App)
}).$mount('#app');
